<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeContratMateriel.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeContratMateriel.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0 mgt-10px">
        <b-field :label="$t('listeContratMateriel.filtre.codeBail')">
          <qd-taginput
            v-model="newCritereRecherche.codes"
            type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.codeFace')">
          <qd-taginput
            v-model="newCritereRecherche.codesFace"
            type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.natureContrat')">
          <qd-taginput
            v-if="natureTags"
            v-model="natureSelected"
            :data="natureTags"
            @typing="getFilteredNatureTags"
            @input="getNatureTag"
            type="is-primary"
            icon="magnify"
            field="libelle"
            autocomplete
            open-on-focus>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeContratReconductible.filtre.typeContrat')"
                      :items="constantes.LISTE_TYPE_CONTRAT"
                      v-model="typeContratSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeContratMateriel.filtre.etat')"
                      :items="constantes.LISTE_ETAT_CONTRAT"
                      v-model="etatContratSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.bailleur')">
          <qd-taginput
            v-model="bailleurSelected"
            icon="magnify"
            :data="filteredBailleur"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="nomCommercial"
            @typing="getFilteredBailleur">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeContratMateriel.filtre.noResult')}}
              </div>
              <div v-else>{{$t('listeContratMateriel.filtre.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.departement')">
          <qd-taginput
            type="is-primary"
            v-model="departementSelected">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.periodeDateContrat')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.periodeContrats.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeContratMateriel.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.periodeContrats.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.datePreavis')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datePreavis.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeContratMateriel.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datePreavis.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0" v-if="agencesSelectionnees.length > 1">
        <agence-tag-input
                      :label="$t('listeContratMateriel.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.materiel')">
          <qd-taginput
            v-model="materielSelected"
            icon="magnify"
            :data="filteredMateriel"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getFilteredMateriel">
            <template slot="empty">
              <div v-if="!isFetchingMateriel">
                {{$t('listeContratMateriel.filtre.noResult')}}
              </div>
              <div v-else>{{$t('listeContratMateriel.filtre.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.dispositif')">
          <qd-taginput
            v-model="dispositifSelected"
            icon="magnify"
            :data="filteredDisppositif"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getFilteredDispositif">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeContratMateriel.filtre.noResult')}}
              </div>
              <div v-else>{{$t('listeContratMateriel.filtre.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.emplacement')">
          <qd-taginput
            v-model="emplacementSelected"
            icon="magnify"
            :data="filteredEmplacement"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getFilteredEmplacement">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeContratMateriel.filtre.noResult')}}
              </div>
              <div v-else>{{$t('listeContratMateriel.filtre.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.codePostal')">
          <b-input v-model="newCritereRecherche.codePostal">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.localite')">
          <ville-tag-input-auto-complete
              :critere-recherche="this.newCritereRecherche"
              table-name="Emplacement"/>
        </b-field>
      </div>
      <div v-if="moduleSecteurActive"
        class="column is-12 pdb-0">
        <b-field :label="$t('listeContratMateriel.filtre.exclureVilles')">
          <ville-tag-input-auto-complete
            :critere-recherche="newCritereRecherche"
            table-name="Emplacement"
            attribut="exclureVilles"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
        <secteur-tag-input
          v-model="secteursSelected"
          :label="$t('listeContratMateriel.filtre.secteurs')"
          :critere="(el) => el.type === constantes.PATRIMOINE"
          :disabled="secteurCurrentUser.length > 0">
        </secteur-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
        <b-field :label="$t('listeContratMateriel.filtre.hasSecteur')">
          <b-select v-model="newCritereRecherche.hasSecteur">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }} </option>
            <option :value="false"> {{ $t('general.non') }} </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('listeContratMateriel.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('listeContratMateriel.filtre.actions.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/tiers';
import { getAll as getAllMateriel } from '@/api/gabed/materiel';
import { getAll as getAllEmplacement } from '@/api/gabed/emplacement';
import { getAll as getAllDispositif } from '@/api/gabed/dispositif';
import {
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO, TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
} from '@/configuration/tiers/tiersConf';
import { LISTE_ETAT_CONTRAT, LISTE_TYPE_CONTRAT } from '@/configuration/baux/contrat/contratConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import genererCritereRechercheContrat from '@/services/baux/contrat/genererCritereRechercheContrat';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser, { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      newCritereRecherche: null,
      bailleurSelected: [],
      filteredBailleur: [],
      isFetching: false,
      constantes: {
        LISTE_ETAT_CONTRAT,
        LISTE_TYPE_CONTRAT,
        PATRIMOINE,
      },
      etatContratSelected: [],
      listeNatureBase: [],
      natureSelected: [],
      natureTags: null,
      materielSelected: [],
      filteredMateriel: [],
      typeContratSelected: [],
      isFetchingMateriel: false,
      emplacementSelected: [],
      filteredEmplacement: [],
      dispositifSelected: [],
      filteredDisppositif: [],
      departementSelected: [],
      secteurCurrentUser: [],
      secteursSelected: [],
    };
  },
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    VilleTagInputAutoComplete,
    secteurTagInput,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getEtatTag() {
      this.etatContratTags = this.listEtatContratBase.filter((etat) => {
        return !this.etatContratSelected.map(a => a.code).includes(etat.code);
      });
    },
    getFilteredEtatTags(text) {
      this.getEtatTag();
      this.etatContratTags = this.etatContratTags.filter((etat) => {
        return etat.libellei18n.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getNatureTag() {
      this.natureTags = this.listeNatureBase.filter((nature) => {
        return !this.natureSelected.map(a => a.id).includes(nature.id);
      });
    },
    getFilteredNatureTags(text) {
      this.getNatureTag();
      this.natureTags = this.natureTags.filter((nature) => {
        return nature.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFilteredBailleur: debounce(async function getAfficheur(search) {
      this.filteredBailleur = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const bailleur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [
                TIERS_SOUS_TYPE_BAILLEUR_PRO,
                TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
                TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
                TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
              ],
              type: TIERS_TYPE_FOURNISSEUR,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        this.filteredBailleur = bailleur.filter((bailleur) => {
          return !this.bailleurSelected.map(
            bailleurSelected => bailleurSelected.id,
          ).includes(bailleur.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredMateriel: debounce(async function getMateriel(search) {
      this.filteredMateriel = [];
      if (!search) return;
      this.isFetchingMateriel = true;
      try {
        const materielsFind = (await getAllMateriel({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        materielsFind.forEach((materiel) => {
          materiel.libelle = materiel.code;
          materiel.libelle += materiel.type && materiel.type.libelle ? ' - ' + materiel.type.libelle : '';
          materiel.libelle += materiel.format && materiel.format.libelle ? ' - ' + materiel.format.libelle : '';
        });
        this.filteredMateriel = materielsFind.filter((materiel) => {
          return !this.materielSelected.map(
            materielSelected => materielSelected.id,
          ).includes(materiel.id);
        });
        this.isFetchingMateriel = false;
      } catch (e) {
        this.isFetchingMateriel = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredEmplacement: debounce(async function getEmplacement(search) {
      this.filteredEmplacement = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const emplacementsFind = (await getAllEmplacement({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        emplacementsFind.forEach((emplacement) => {
          emplacement.libelle = emplacement.code;
        });
        this.filteredEmplacement = emplacementsFind.filter((emplacement) => {
          return !this.emplacementSelected.map(
            emplacementSelected => emplacementSelected.id,
          ).includes(emplacement.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredDispositif: debounce(async function getDispositif(search) {
      this.filteredDisppositif = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const dispositifsFind = (await getAllDispositif({
          query: {
            auto: search,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        dispositifsFind.forEach((dispositif) => {
          dispositif.libelle = dispositif.code;
        });
        this.filteredDisppositif = dispositifsFind.filter((dispositif) => {
          return !this.dispositifSelected.map(
            dispositifSelected => dispositifSelected.id,
          ).includes(dispositif.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    appliquerCritere() {
      this.newCritereRecherche.tiersId = this.bailleurSelected;
      this.newCritereRecherche.departements = this.departementSelected;
      this.newCritereRecherche.materielsId = this.materielSelected;
      this.newCritereRecherche.emplacementsId = this.emplacementSelected;
      this.newCritereRecherche.dispositifsId = this.dispositifSelected;
      this.newCritereRecherche.etat = this.etatContratSelected.map(el => { return el.code; });
      this.newCritereRecherche.naturesId = this.natureSelected.map(el => { return el.id; });
      this.newCritereRecherche.contratType = this.typeContratSelected.map(el => {
        return el.code;
      });
      if (this.moduleSecteurActive) {
        this.newCritereRecherche.secteurIds = this.secteursSelected.map(e => e.id);
      }
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.newCritereRecherche = cloneDeep(genererCritereRechercheContrat());
      this.bailleurSelected = [];
      this.materielSelected = [];
      this.emplacementSelected = [];
      this.dispositifSelected = [];
      this.initializeAutoComplete();
      this.departementSelected = [];
      this.typeContratSelected = [];
      this.secteursSelected = this.secteurCurrentUser;
    },
    initializeAutoComplete() {
      if (this.newCritereRecherche.etat) {
        this.etatContratSelected = this.constantes.LISTE_ETAT_CONTRAT.filter((c) => {
          return this.newCritereRecherche.etat.includes(c.code);
        });
      }
      if (this.newCritereRecherche.contratType.length > 0) {
        this.typeContratSelected = this.constantes.LISTE_TYPE_CONTRAT.filter((c) => {
          return this.newCritereRecherche.contratType.includes(c.code);
        });
      }
      if (this.newCritereRecherche.naturesId) {
        this.natureSelected = this.listeNatureBase.filter((c) => {
          return this.newCritereRecherche.naturesId.includes(c.id);
        });
      }
      this.getNatureTag();
    },

    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRecherche);
        await this.loadParametres([
          typesParametres.PARAMETRES_KEYS.contratNature,
        ]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        ]);
        this.bailleurSelected = this.newCritereRecherche.tiersId;
        this.materielSelected = this.newCritereRecherche.materielsId;
        this.emplacementSelected = this.newCritereRecherche.emplacementsId;
        this.dispositifSelected = this.newCritereRecherche.dispositifsId;
        this.departementSelected = this.newCritereRecherche.departements;

        this.secteursSelected = await getSecteursByIds(
          this.critereRecherche.secteurIds, PATRIMOINE);
        this.secteurCurrentUser = await getSecteursIdByUser(PATRIMOINE, true);
        if (this.secteurCurrentUser.length) this.secteursSelected = this.secteurCurrentUser;
        this.newCritereRecherche.secteurIds = this.secteursSelected.map(e => e.id);

        this.listEtatContratBase = cloneDeep(this.listEtatContrat);
        this.listeNatureBase = this.contratNature;
        this.initializeAutoComplete();

        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    contratNature() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.contratNature);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
